import { ObjectValues } from 'types';

export type ShareableLinkListenEvents = ObjectValues<
  typeof SHAREABLE_LINK_LISTEN_EVENTS
>;

export const SHAREABLE_LINK_LISTEN_EVENTS = {
  DOWNLOAD_SUCCESSFULLY: 'downloaded-successfully',
  DOWNLOAD_FAILED: 'downloaded-failed',
  NDA_STATUS_UPDATED: 'secure-link-nda-status-updated',
};
